import { render } from "./index.vue?vue&type=template&id=22ac1ffd&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"

import "./index.vue?vue&type=style&index=0&id=22ac1ffd&lang=less"
import "./index.vue?vue&type=style&index=1&id=22ac1ffd&lang=less&scoped=true"

import exportComponent from "/Users/bld/web/doctor2/doctor-pc/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-22ac1ffd"]])

export default __exports__